import { useState } from "react";
import {
  Phone, Mail, Calendar, Hash, Droplet, Mars, User,
  Download, Edit, MoreHorizontal, Clock, CalendarDays,
  FileText, AlertCircle, Stethoscope, ChevronRight,
  CheckCircle, Activity, Heart, Eye
} from "lucide-react";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, Legend
} from "recharts";

import PersonalInfoCard from "./components/PersonalInfoCard";
import StatsGrid from "./components/StatsGrid";
import VitalsSection from "./components/VitalsSection";
import TabSection from "./components/TabSection";
import Breadcrumbs from "../../components/private/Breadcrumbs";
import { useSelector } from "react-redux";

export default function PatientProfile() {
  const [isPatientExists, setIsPatientExists] = useState(true);
  const darkMode = useSelector((state) => state.settings.darkMode);

  if (!isPatientExists) {
    return (
      <div>
        <Breadcrumbs />
        <div
          className={`flex flex-col  rounded-lg p-3 min-h-[calc(100vh-5rem)] mx-3 ${
            darkMode ? "dashboard-secondary-color-dark" : "bg-white"
          }`}
        >
          <div className="min-h-screen flex flex-col items-center justify-center font-sans ">
            <AlertCircle size={48} className="text-rose-600 dark:text-rose-400" />
            <h2 className="mt-4 text-rose-600 dark:text-rose-400 text-xl font-semibold">
              Patient Not Found
            </h2>
            <p className="mt-2 text-gray-500 dark:text-gray-400">
              The patient you are looking for does not exist.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Breadcrumbs />
      
        
          <div className="mx-3 flex flex-col gap-3">
            <PersonalInfoCard setIsPatientExists={setIsPatientExists} />
            <TabSection />
            <VitalsSection />
          </div>
   
    
    </div>
  );
}